import { Button, Empty, Input, Popconfirm, Select, Space, Spin, Table, Tag, Typography } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../../app/store';
import { getUserDatas } from './slice';
import { Link } from 'react-router-dom';
import account from '../../../../apis/admin/accoutService';
import notificationHandler from '../../../atoms/Notification';
import { DeleteOutlined, FormOutlined, LoadingOutlined, PlusCircleOutlined, SearchOutlined, UserOutlined } from '@ant-design/icons';
import rolesAdmin from '../../../../apis/admin/rolesService';
import './account.scss'
interface DataType {
  key: string;
  name: string;
  age: number;
  address: string;
  tags: string[];
}
const { Search } = Input;

const ListAccount = () => {
  const { user }: any = useSelector((state: RootState) => state.userlist)
  const [status, setStatus] = React.useState<any>('');
  const [search, setSearch] = React.useState<any>('');
  const [dataRole, setDataRole] = React.useState<any>();
  const [role, setRole] = React.useState<any>(null);
  const [loading, setLoading] = React.useState(false);
  const [inputValue, setInputValue] = React.useState('');
  const [currentPage, setCurrentPage] = React.useState(1);


  const handlePageChange = (page: any) => {
    setCurrentPage(page);

  };

  const [pageSize, setPageSize] = React.useState(10);
  const displayedIndex = (index: any) => (currentPage - 1) * pageSize + index + 1;


  const antIcon = <LoadingOutlined style={{ fontSize: 70, position: 'fixed' }} spin />;

  const dispatch = useDispatch<AppDispatch>()

  const customButton = <Button className='border-none mr-3' icon={<SearchOutlined />} />;

  const { Title } = Typography;

  useEffect(() => {
    setLoading(true)
    dispatch(getUserDatas({ status, search, role })).then().catch().finally(() => setLoading(false))
  }, [dispatch])
  const handleRemove = (id: number) => {
    setLoading(true);
    account.removeAcount(id).then(() => {
      notificationHandler('success', 'Xóa tài khoản thành công!')
      dispatch(getUserDatas({ status: status, search, role }))
      setLoading(false);
    }).catch((err) => {
      notificationHandler('error', 'Xóa tài khoản không thành công!')
      setLoading(false);
    })
  }
  useEffect(() => {
    rolesAdmin.getRolesData().then((role: any) => {
      setDataRole(role.data.data.payload);
    })
  }, [])

  const handleSearchStatus = (value: any) => {
    if (value == undefined) value = ''
    setStatus(value)
    setCurrentPage(1)
    dispatch(getUserDatas({ status: value, search, role }))
  };

  const handleRole = (value: number) => {
    setRole(value);
    dispatch(getUserDatas({ status, search, role: value })).unwrap().then((item) => {
      setCurrentPage(1)
    })

  }
  const onSearch = (value: string) => {
    setInputValue(value);
    setSearch(value);
    dispatch(getUserDatas({ status, search: value, role })).unwrap().then((item) => {
      setCurrentPage(1)
    })
  };

  const columns: ColumnsType<DataType> = [
    {
      title: 'STT',
      dataIndex: 'index',
      key: 'index',
      align: 'center',
      width: '8%',
      render: (_: any, __: any, index: any) => displayedIndex(index),
    },
    {
      title: 'Tài khoản',
      dataIndex: 'username',
      key: 'username',
      align: 'center',
      width: '30%',
      sorter: (a: any, b: any) => a.username.localeCompare(b.username),
      render: (value: any, record: any, index: number) => {
        return (
          <div title={value} className='truncates mx-auto'>{value}</div>
        )
      },
    },
    {
      title: 'Quyền',
      dataIndex: 'roles',
      key: 'roles',
      align: 'center',
      width: "20%",
      render: (value: any, record: any, index: number) => {
        return (
          <div>{record.roles?.map((item: any, key: number) => {
            return (
              <Tag color="blue" key={item.id}>{item.roleName}</Tag>
            )
          })}</div>
        )
      },
    },
    {
      title: 'Trạng thái',
      key: 'status',
      dataIndex: 'status',
      align: 'center',
      width: "20%",
      render: (status: number, record: any, index: number) => {
        let color = 'green';
        let color1 = 'volcano';
        let text1 = 'Hoạt động';
        let text = 'Không hoạt động'
        return (
          <div>
            {status === 1 && <Tag color={color} key={status} className='py-1'>
              {text1}
            </Tag>}
            {status === 0 && <Tag color={color1} key={status} className='py-1'>
              {text}
            </Tag>}
            {status === 0 && ''}
          </div>
        )
      }
    },
    {
      title: 'Hành động',
      align: 'center',
      width: '10%',
      render: (text: string, record: any) => {
        return (
          <Space size="small">
            <Button className='mr-1 hover:border-[#FAAD14] hover:text-[#FAAD14] bg-[#FAAD14] border-[#FAAD14] p-[5px_10px] text-white '><Link to={`/admin/editAccount/${record.userId}`} className='flex items-center'><FormOutlined className='mr-1' />Sửa</Link></Button>
            <Popconfirm
              title="Bạn có muốn xóa tài khoản?"
              okText="Có"
              onConfirm={() => handleRemove(record.userId)}
              cancelText="Không"
              okType='danger'
            >
              <Button danger className='bg-[#ff4d4f] text-white ' loading={loading}><div className='flex items-center'><DeleteOutlined className='pr-1' />Xóa</div></Button>
            </Popconfirm>
          </Space>
        )
      }
    },
  ];
  return (
    <>
      <div className='flex justify-between' id='account'>
        <Spin indicator={antIcon} spinning={loading} />
        <div className='flex w-[80%]'>
          <Input style={{ width: '30%' }} allowClear placeholder="Nhập tên tài khoản tìm kiếm" value={inputValue} onBlur={(e) => setInputValue(e.target.value.trim())} maxLength={200} onChange={(e) => onSearch(e.target.value)} prefix={<SearchOutlined />} />

          <Select className='w-[20%] ml-3' placeholder='Danh sách quyền' onChange={handleRole} allowClear>
            {/* <Select.Option value=''>Chọn quyền</Select.Option> */}
            {dataRole?.map((item: any, key: number) => <Select.Option key={key} value={item.id}>{item.roleName}</Select.Option>)}
          </Select>
          <Select
            style={{ width: '15%' }}
            className='ml-3'
            onChange={handleSearchStatus}
            placeholder={'Chọn trạng thái'}
            allowClear
            options={[
              // { value: '', label: 'Chọn trạng thái' },
              { value: 0, label: 'Không hoạt động' },
              { value: 1, label: 'Hoạt động' },
            ]}
          />
        </div>
        <Button type='primary' className='p-[5px_15px] border-green-600 hover:border-green-600 hover:text-green-600 hover:bg-white bg-green-600 text mb-4 rounded-sm '><Link to={'/admin/createAccount'} className='flex items-center'><PlusCircleOutlined className='mr-1' /> Thêm mới</Link></Button>
      </div>
      <Title className='mt-[15px]' level={3}>Danh sách tài khoản</Title>
      <Table
        pagination={{
          locale: { items_per_page: 'bản ghi / Trang' },
          defaultPageSize: 10,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50'],
          current: currentPage,
          onShowSizeChange(current, size) {
            setPageSize(size)
          },
          showTotal: (total: any, range: any) => `${range[0]}-${range[1]} Tổng ${total} bản ghi`
        }}
        columns={columns}
        dataSource={user}
        rowKey={(record: any) => record.userId}
        className='overflow-auto mt-[10px]'
        locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_DEFAULT} description="Không có dữ liệu!" /> }}
      />
    </>
  )
}

export default ListAccount
